import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  Audio,
  Html
} from "../../../../components";
import * as styles from "./styles.scss";
import { tl } from "../../../../utils";

interface IProps {
  value: any;
}

const downloadFile = (src: string) => {
  window.open(src);
};

const renderFiles = (props: any, i: any) => (
  <div className={styles.file} key={i}>
    <div className={styles.filename}>
      {props.src
      ? props.fileScript ? (
        <Html>{props.fileScript}</Html>
      ) : (
        <Audio src={props.src}/>
      ) : props.srcOriginal ? (
        <a href={props.srcOriginal} target="_blank">
          {`${tl('Скачать файл')} ${decodeURI(props.srcOriginal).split("/").reverse()[0]}`}
        </a>
      ) : <div>{tl("Файл не найден.")}</div>}
    </div>
  </div>
);

export const Record = ({ value }: IProps) => {
  if(value.length === 0){
    return (
      <div>
        <span>Не был дан ответ</span>
        <div>
          <b>Пропущен!</b>
        </div>
      </div>
    );
  }

  return (
    <div>{value.map(renderFiles)}</div>
  );
};
